const UK_TEL_SELECTOR = 'a[href^="tel:+44"]';
const UK_TEL_PATTERN = /^\+44\d{9,10}$/;

const normalizePhone = (value) => (value || '').replace(/[^0-9+]/g, '');

const formatUkPhoneDisplay = (value) => {
    const normalized = (value || '').replace(/\s+/g, '');

    if (!UK_TEL_PATTERN.test(normalized)) {
        return value;
    }

    const nationalNumber = normalized.slice(3);
    let segments = [nationalNumber];

    if (nationalNumber.length === 10) {
        segments = [nationalNumber.slice(0, 4), nationalNumber.slice(4)];
    } else if (nationalNumber.length === 11) {
        segments = [nationalNumber.slice(0, 4), nationalNumber.slice(4, 7), nationalNumber.slice(7)];
    } else if (nationalNumber.length === 9) {
        segments = [nationalNumber.slice(0, 3), nationalNumber.slice(3)];
    }

    return `+44 (0) ${segments.filter(Boolean).join(' ')}`;
};

const decorateTelephoneAnchors = (scope = document) => {
    scope.querySelectorAll(UK_TEL_SELECTOR).forEach((anchor) => {
        const href = anchor.getAttribute('href') || '';
        const rawNumber = href.replace(/^tel:/, '').replace(/\s+/g, '');

        if (!UK_TEL_PATTERN.test(rawNumber)) {
            return;
        }

        const currentText = (anchor.textContent || '').trim();
        const normalizedText = normalizePhone(currentText);

        if (currentText && normalizedText !== rawNumber) {
            return;
        }

        anchor.textContent = formatUkPhoneDisplay(rawNumber);
    });
};

const initTelephoneDecorator = () => {
    const run = () => {
        decorateTelephoneAnchors(document);
    };

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', run, { once: true });
        return;
    }

    run();
};

export { decorateTelephoneAnchors, formatUkPhoneDisplay };
export default initTelephoneDecorator;
